import apiService from '../apiService';

import svcConfig from './chnlConfig';

const chnlService = {
  gatewayLogon: (request) => {
    return apiService('gatewayLogon', svcConfig, request);
  },
  saasTokenAuth: (request) => {
    return apiService('saasTokenAuth', svcConfig, request);
  },
  dspTokenAuth: (request) => {
    return apiService('dspTokenAuth', svcConfig, request);
  },
  gatewayLogoff: () => {
    return apiService('gatewayLogoff', svcConfig);
  },
  keepAlive: () => {
    return apiService('keepAlive', svcConfig);
  },
};

export default chnlService;
